const languages = {
    es: {
        label: 'Spanish'
    },
    en: {
        label: 'English'
    },
    ru: {
        label: 'Russian'
    },
    tr: {
        label: 'Turkish'
    }
};

export default languages;
